import styles from './searchBar.module.scss';
import { Suspense } from 'react';
import ShortcutIconSvg from '../shortcuts/ShortcutIconSvg.tsx';
import type { Shortcut } from '../shortcuts/type.ts';
import i18n from '../../../i18n.ts';
import { highlightedText } from './highlightedTextUtils';

const ShortcutTile = ({
  shortcut,
  onClick,
  query,
}: {
  shortcut: Shortcut;
  onClick: (s: Shortcut) => void;
  query: string;
}) => {
  const currentLang = i18n.languages[0];
  const { color, iconContent } = shortcut;

  return (
    <div
      key={`${shortcut.module}-${shortcut.title}`}
      onClick={() => onClick(shortcut)}
      className={styles.option}
      data-testid="shortcut-box"
    >
      <div className={styles.iconBox}>
        <Suspense fallback={null}>
          <ShortcutIconSvg fill={color} color={color} iconContent={iconContent} />
        </Suspense>
      </div>
      <div className={styles.optionText}>
        <span className={styles.optionTitle}>
          {highlightedText(shortcut.titles?.[currentLang] ?? shortcut.titles?.['en'] ?? shortcut.title, query)}
        </span>
        <span className={styles.optionDescription}>{shortcut.moduleTitle}</span>
      </div>
    </div>
  );
};

export default ShortcutTile;
